import { render, staticRenderFns } from "./tuzhuangliangting.vue?vue&type=template&id=7a3737e2&scoped=true&"
import script from "./tuzhuangliangting.vue?vue&type=script&lang=js&"
export * from "./tuzhuangliangting.vue?vue&type=script&lang=js&"
import style0 from "./tuzhuangliangting.vue?vue&type=style&index=0&id=7a3737e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3737e2",
  null
  
)

export default component.exports